export default __webpack_public_path__ + "img/catIcon5.82fa00e8.svg";